import { Theme } from '@mui/material';
import styled from '@emotion/styled';

type ParamsStyle = {
    theme?: Theme;
}

type ParamsStyleCard = {
    theme?: Theme;
    activeCar: string;
}

export const ContentCarrousel = styled.ul(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    display: flex;
    z-index: -1;
    margin: 1.125rem 0;

    .scroll-container {
        width: 100%;
        gap: .5rem;
        display: flex;
        overflow: auto;
    }

    ::-webkit-scrollbar {
        width: 0px;
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        margin: 1.125rem 0 1.375rem;
    }
`);

export const ItemList = styled.li(
    ({ theme }: ParamsStyle) => `
        min-width: calc(50% - .875rem);
        height: 100%;
        position: relative;
        padding: 0 0 .4875rem;
        border-radius: 7.6285px 7.6285px 0 0;

        :after {
            position: absolute;
            content: '';
            width: 100%;
            bottom: 0px;
            height: .4875rem;
            border-radius: 1px;
            background-color: ${theme?.palette.secondary.main};

            @media(min-width: ${theme?.breakpoints.values.md}px) {
                height: .625rem;
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            min-width: calc(33% - .875rem);
            padding: 0 0 .625rem;
        }
`);

export const CardCar = styled.div(
    ({ theme, activeCar }: ParamsStyleCard) => `
        height: 100%;
        display: flex;
        padding: .25rem 0;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
        border-radius: 7.6285px 7.6285px 0 0;
        border-top: 1px solid ${theme?.palette.primary.main};
        border-left: 1px solid ${theme?.palette.primary.main};
        border-right: 1px solid ${theme?.palette.primary.main};

        background-color: ${activeCar === 'active' ? theme?.palette.primary.main : 'transparent'};

        img {
            height: 100%;
            max-width: 100%;
            max-height: 40px;
        }
        @media(min-width: ${theme?.breakpoints.values.md}px) {
            padding: .375rem 0;

            img {
                max-height: 100%;
            }
        }
`);
